export const WHATSAPP_NUMBER = '5511983180033'
export const WHATSAPP_DISPLAY = '(11) 98318-0033'